import axios from "axios";
import { generatePath } from "react-router-dom";
import { ValidationError } from "../../library/classes/exceptions";
import { isNil, omitBy } from "../../library/utilities/common.js";
import { defaultHeaders } from "./default-headers";


// eslint-disable-next-line no-undef
const DEBUG = import.meta.env.NODE_ENV === 'development';

const redirectTo404 = async () => {
  throw new Response("", { status: 404 });
}

// Thrown `redirect()` Responses are only caught by React Router loaders/actions.
// Axios calls made from event handlers (outside a loader) need a real navigation instead.
const goToLogin = (token, referrer = '') => {
  let loginUrl = generatePath('/authenticate/:quotationToken', { quotationToken: token });
  if (referrer) {
    const params = new URLSearchParams();
    params.set("from", referrer);
    loginUrl = `${loginUrl}?${params.toString()}`;
  }
  window.location.href = loginUrl;
}


export const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: `${import.meta.env.VITE_BASE_API_URL}/${import.meta.env.VITE_VERSION_V1}/`,
  //baseURL: `http://${window.location.hostname}:3011/clientapi/${import.meta.env.VITE_VERSION_V1}/`,
});

// Intercepting requests
axiosInstance.interceptors.request.use(
  (request) => {
    const headers = {
      ...defaultHeaders(),
      ...request?.headers
    };
    /* eslint-disable no-console */
    if (DEBUG)
      console.info(`%c ${request.method?.toUpperCase()} ===> ${request.url}`, 'background: #62687a; color: #fff');
    /* eslint-enable no-console */

    return { ...request, headers };
  },
  (error) => Promise.reject(error)
);


// Intercepting responses
axiosInstance.interceptors.response.use(
  (response) => {
    // do something here
    if (!response.data.status) {
      console.log({ response })
      if (response.data?.type === 'ValidationError') {
        return Promise.reject(new ValidationError('Server Validation Error Occured', response.data?.errors))
      }
      return Promise.reject(response.data)
    }
    // return new Promise(resolve => setTimeout(() => {
    //   resolve(response.data);
    // }, 2000))
    return response.data
  },
  async (error) => {
    const statusCode = error.response?.status || 500;

    if (DEBUG) console.error(statusCode, error.message);

    switch (statusCode) {
      case 403:
      case 401:
      case 430: {
        // do something else, redirecting to login for the time being
        goToLogin(error?.config?.params?.token, window.location.pathname);
        return new Promise(() => {}); // navigation is in flight; never resolve/reject
      }
      case 404: {
        //Throw error directly in case of non get 404
        if (error.config.method !== 'get') {
          return Promise.reject(new Error('Invalid Action'))
        }
        return redirectTo404();
      }
      default:
        return Promise.reject(error);
    }
  }
)

export const axiosCancellable = (action) => {
  const controller = new AbortController();
  const cancelIntercept = axiosInstance.interceptors.request.use((config) => {
    config.signal = controller.signal
    return config
  },
    (error) => Promise.reject(error)
  )
  action().then(() => {
    axiosInstance.interceptors.request.eject(cancelIntercept)
  })
  return controller
}

export const removeNill = (obj) => {
  return omitBy(obj, isNil);
}